// base rc-switch 1.9.0
import Switch from './Switch';

export default Switch;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-switch/index.js
// module id = 865
// module chunks = 0